import React from 'react';
import { Button } from '../../../components/ui/button';
import { Separator } from "../../../components/ui/separator";
import {
    AlertDialog,
    AlertDialogCancel,
    AlertDialogContent,
    AlertDialogDescription,
    AlertDialogFooter,
    AlertDialogTitle
} from '../../../components/ui/alert-dialog';
import { Badge } from "../../../components/ui/badge"

const arePermissionsEqual = (oldPermissions, newPermissions) => {
    const oldKeys = Object.keys(oldPermissions);
    const newKeys = Object.keys(newPermissions);

    if (oldKeys.length !== newKeys.length) return false;

    for (let key of oldKeys) {
        const oldValues = oldPermissions[key].sort();
        const newValues = newPermissions[key].sort();

        if (oldValues.length !== newValues.length) return false;

        for (let i = 0; i < oldValues.length; i++) {
            if (oldValues[i] !== newValues[i]) return false;
        }
    }

    return true;
};

const ReviewBox = ({
    open,
    handleClose,
    confirmAction,
    reviewPermissions
}) => {

    const isSaveButtonDisabled = arePermissionsEqual(reviewPermissions.old, reviewPermissions.new);

    return (
        <AlertDialog open={open} onDismiss={handleClose}>
            <AlertDialogContent>
                <AlertDialogTitle>Review your changes</AlertDialogTitle>
                <AlertDialogDescription className="hidden">Review Permissions</AlertDialogDescription>
                <div
                    className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4"
                    style={{ maxHeight: '60vh', overflowY: 'auto' }}
                >
                    <div className="w-full md:w-1/2">
                        <h2 className="font-semibold mb-3">Old Permissions:</h2>
                        {Object.entries(reviewPermissions.old).map(([moduleName, permissions]) => (
                            <div key={moduleName}>
                                <h3 className='text-sm font-semibold'>{moduleName}</h3>
                                <ul className='list-disc pl-5 text-sm mb-2'>
                                    {permissions.map(permission => (
                                        <li key={permission}>{permission}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                    <Separator orientation="vertical" className="hidden md:block h-full" />
                    <Separator className="block md:hidden w-full" />
                    <div className="w-full md:w-1/2">
                        <h2 className="font-semibold mb-3">Updated Permissions:</h2>
                        {Object.entries(reviewPermissions.new).map(([moduleName, permissions]) => (
                            <div key={moduleName}>
                                <h3 className='text-sm font-semibold'>{moduleName}</h3>
                                <ul className='list-disc pl-5 text-sm mb-2'>
                                    {permissions.map(permission => (
                                        <li key={permission}>{permission}</li>
                                    ))}
                                </ul>
                            </div>
                        ))}
                    </div>
                </div>

                {isSaveButtonDisabled && <>
                    <Badge variant="outline" className="block md:hidden">No changes to save</Badge>
                    <AlertDialogFooter className="md:justify-between">
                        <Badge variant="outline" className="hidden md:block">No changes to save</Badge>
                        <div className='hidden md:block'>
                            <AlertDialogCancel onClick={handleClose} className="mr-2">Cancel</AlertDialogCancel>
                            <Button type="button" onClick={confirmAction} disabled={isSaveButtonDisabled}>Save Permissions</Button>
                        </div>
                        <AlertDialogCancel onClick={handleClose} className="block md:hidden">Cancel</AlertDialogCancel>
                        <Button type="button" onClick={confirmAction} disabled={isSaveButtonDisabled} className="block md:hidden">Save Permissions</Button>
                    </AlertDialogFooter>
                </>}

                {!isSaveButtonDisabled && <AlertDialogFooter>
                    <AlertDialogCancel onClick={handleClose}>Cancel</AlertDialogCancel>
                    <Button type="button" onClick={confirmAction} disabled={isSaveButtonDisabled}>Save Permissions</Button>
                </AlertDialogFooter>}

            </AlertDialogContent>
        </AlertDialog>
    );
}

export default ReviewBox;
